export default {
	title: 'Uzavření výkazu dokumentů',
	subTitle: 'DATUM VYKÁZÁNÍ',
	reportedProductionTitle: 'VYKÁZANÁ PRODUKCE',
	documentTitle: 'Vykázané dokumenty',
	seller: 'Obchodník',
	sellerSellerIn: 'Obchodník Získatelské číslo',
	sellerAgencyNumber: 'Obchodník Agenturní číslo',
	ppz: 'Podobchodník',
	ppzSellerIn: 'Podobchodník Získatelské číslo',
	ppzAgencyNumber: 'Podobchodník Agenturní číslo',
	signature: 'Podpis',
	manager: 'Manažer',
	managerSellerIn: 'Manažer Získatelské číslo',
	managerAgencyNumber: 'Manažer Agenturní číslo',
	client: 'Klient ',
	reportedDate: 'Datum vykázání',
	policyNo: 'Číslo PS',
	proposalNo: 'Číslo návrhu PS',
	document: 'Dokument',
	scan: 'Sken',
	name: 'Název',
	policyOpenDate: 'Datum sjednání',
	product: 'Produkt',
	contactSource: 'Zdroj kontaktu',
	originalSource: 'Původní kontakt',
	share: 'Podíl na produkci v %',
	sellerIn: 'Získatelské číslo',
	AgencyNumber: 'Agenturní číslo',
	BV: 'BP',
	JV: 'JP',
	biometricScan: 'Biometrie',
	close: 'Zrušit',
	closeReportedDocument: 'Uzavřít výkaz',
	closeMessage:
		'Opravdu chcete stránku opustit bez uložení dat? Po potvrzení opustíte modální okno bez jakýchkoliv změn.',
};
